export const COUPON_RESET_PERIOD = [
    'immediate',
    'day',
    'week',
    'month',
    'year',
];
export const COUPON_TYPES = [
    'ticket-percent',
    'ticket-fixed',
    'item-percent',
    'item-fixed',
];
export const COUPON_CHANNELS = ['app', 'website'];
export const COUPON_ORDER_TYPES = ['pickup', 'delivery'];
/**
 * Coupon campaigns that we want to be queryable in the paginate coupons endpoint
 */
export const COUPON_CAMPAIGNS = [
    'conversion-cards',
    'in-store-app-adoption',
];
export const MENU_TYPES = ['olo', 'catering'];
export const MENU_ENTITY_COLLECTIONS = [
    'Category',
    'Coupon',
    'Item',
    'Menu',
    'Modifier',
    'ModifierSet',
];
export const ALLERGENS = [
    'dairy',
    'eggs',
    'fish',
    'gluten',
    'mango',
    'peanuts',
    'sesame',
    'shellfish',
    'soy',
    'tree-nuts',
];
const getClosedDailyHours = () => ({
    hours: [],
    open: false,
});
export const getClosedHoursInfo = () => ({
    sunday: getClosedDailyHours(),
    monday: getClosedDailyHours(),
    tuesday: getClosedDailyHours(),
    wednesday: getClosedDailyHours(),
    thursday: getClosedDailyHours(),
    friday: getClosedDailyHours(),
    saturday: getClosedDailyHours(),
});
//# sourceMappingURL=constants.js.map